import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { OutkeepPermissionService } from '../services/permission/outkeep-permission.service';
import { AppRoutePaths } from '@core/types/app-route-paths';
import { filter, map, of, switchMap, take } from 'rxjs';
import { AccountService } from '@core/services/account/account.service';
import { OutkeepPermission } from '@outkeep/shared';

export const PermissionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const router = inject(Router);
  const permissionService = inject(OutkeepPermissionService);
  const accountService = inject(AccountService);
  const permission = route.data['permission'];

  if (!permission) {
    return true;
  }

  return accountService.authState$.pipe(
    filter(state => state !== 'unknown'),
    take(1),
    switchMap(state => {
      // Для анонима не делаем fallback на no-permission: login уже открыт,
      // а route должен активироваться на исходном URL до reload после входа.
      if (state === 'anonymous') {
        return of(true);
      }

      return permissionService.hasPermission$(permission).pipe(
        switchMap(isAllow => {
          if (isAllow) {
            return of(true);
          }

          return permissionService
            .hasPermission$(OutkeepPermission.LogistOn)
            .pipe(
              take(1),
              map(canUseRequests =>
                canUseRequests
                  ? router.createUrlTree([AppRoutePaths.AllRequests])
                  : router.createUrlTree([AppRoutePaths.NoPermission]),
              ),
            );
        }),
      );
    }),
  );
};
